// extracted by mini-css-extract-plugin
module.exports = {"title":"AdditionalFuns_title__2-ciz"};